import { useQuery } from '@tanstack/react-query'
import ms from 'ms'

import { useAuth } from '@/hooks/useAuth'
import { QUERY_KEYS } from '@/lib/queryKeys'
import stateService from '@/lib/services/stateService'

export function useAppStateQuery() {
  const { isCompanyUser } = useAuth()

  return useQuery({
    queryKey: QUERY_KEYS.appState,
    enabled: isCompanyUser,
    queryFn: () => stateService.getStates(),
    staleTime: ms('5s'),
  })
}
